import { extendTheme } from "@chakra-ui/react";
// File fontsource default is 400
// So we want to use it as we link on file index.html we need to config it inside node module
// nodeModule -> @fontsource -> inter or poppins -> index.css (config there)
import "@fontsource/poppins";
import "@fontsource/inter";
import "@fontsource/kantumruy-pro";
export const config = {
	initialColorMode: "light",
	useSystemColorMode: false,
};

export const theme = extendTheme({
	config,
	colors: {
		brand: {
			50: "#FFE6E9",
			100: "#FEB8C1",
			200: "#FE8B99",
			300: "#FD5D71",
			400: "#FD3049",
			500: "#FD0221",
			600: "#CA021A",
			700: "#980114",
			800: "#65010D",
			900: "#330007",
		},
		redAlt: {
			50: "#fff7f7",
			100: "#ffefef",
			200: "#ffd6d6",
			300: "#ffbdbd",
			400: "#ff8c8c",
			500: "#ff5b5b",
			600: "#e65252",
			700: "#bf4444",
			800: "#993737",
			900: "#7d2d2d",
		},
	},
	styles: {
		global: {
			"*": {
				"&::-webkit-scrollbar": {
					width: "10px",
					height: "10px",
				},
				// body: {
				// 	bg: "#F4F7FE",
				// },
				// "&::-webkit-scrollbar-track": {
				// 	width: "6px",
				// 	height: "4px",
				// 	background: "rgba(0, 0, 0, 0.05)",
				// },
				"&::-webkit-scrollbar-thumb": {
					background: "rgba(0, 0, 0, 0.16)",
					// background: "rgba(0, 0, 0, 0.16)",
					borderRadius: "24px",
				},

				scrollbarWidth: "thick",
			},
		},
	},

	fontSizes: {
		sm: "0.83rem",
		md: "0.9rem",
	},
	fonts: {
		heading: "Poppins, sans-serif",
		body: "Kantumruy Pro, sans-serif",
	},
	components: {
		Button: {
			baseStyle: {
				// fontWeight: "medium",
			},
			variants: {
				duotone: (props) => ({
					bg: `${props.colorScheme}.100`,
					color: `${props.colorScheme}.600`,
					border: `1px solid`,
					px: "var(--chakra-space-3)",
					borderColor: `${props.colorScheme}.500`,
					_hover: { bg: `${props.colorScheme}.200` },
				}),
			},
		},
		Input: {
			defaultProps: {
				focusBorderColor: "brand.400",
			},
			variants: {
				outline: {
					field: {
						_disabled: {
							opacity: 1,
							_hover: {
								borderColor: "inherit",
								cursor: "default",
							},
						},
					},
				},
			},
		},
		CheckBox: {
			variants: {
				bg: "brand.100",
			},
		},
		NumberInput: {
			defaultProps: {
				focusBorderColor: "brand.400",
			},
		},
		Textarea: {
			defaultProps: {
				focusBorderColor: "brand.400",
			},
			variants: {
				outline: {
					_disabled: {
						opacity: 1,
						_hover: {
							borderColor: "inherit",
							cursor: "default",
						},
					},
				},
			},
		},
	},
});
